import { useState } from 'react';
import Menu from '../../components/Menu/Menu';
import Footer from '../../components/Footer';
import './TreinoInicial.css';

function TreinoInicial() {
    const steps = [
        {
            title: 'Boas-vindas e Visão Geral',
            subtitle: 'Entenda o fluxo completo do sistema',
            description: 'O EasyCripto é uma plataforma completa de trading automatizado que permite operar criptomoedas na Binance de forma inteligente. Este treinamento irá guiá-lo através de todas as funcionalidades, desde a configuração inicial até a criação de estratégias automatizadas.',
            items: [
                'Dashboard: visualize gráficos, cotações em tempo real e estatísticas do mercado',
                'Menu lateral: acesso rápido a todos os módulos do software',
                'Fluxo recomendado: Configurações → Símbolos → Monitores → Templates → Estratégias → Automações',
                'Cada módulo tem uma função específica e trabalha em conjunto com os outros'
            ],
            setup: [
                'Faça login com suas credenciais',
                'Navegue pelo menu lateral para conhecer as opções disponíveis',
                'Acesse o Dashboard para ver o mercado em tempo real',
                'Configure suas chaves de API na página de Configurações'
            ],
            tips: [
                'Comece sempre pelas Configurações antes de usar outras funcionalidades',
                'Use o menu "Começando" para configuração inicial da conta Binance',
                'Mantenha suas chaves de API seguras e nunca as compartilhe'
            ]
        },
        {
            title: 'Configurações Essenciais',
            subtitle: 'Conecte sua exchange e configure alertas',
            description: 'As configurações são a base de tudo. Sem elas, o sistema não consegue se conectar à Binance nem enviar notificações. Configure suas chaves de API, email e Telegram para começar a operar.',
            items: [
                'API Keys Spot: permitem ler saldos, consultar preços e enviar ordens de compra/venda',
                'API Keys Futures (opcional): necessárias apenas se você operar contratos futuros',
                'Permissões importantes: habilite "Leitura" e "Trading", mas NUNCA habilite "Saques" por segurança',
                'Email: receba alertas de operações, erros e eventos importantes',
                'Telegram: notificações instantâneas via bot (informe apenas o Chat ID)',
                'SendGrid API Key: necessário para envio de emails (configure no painel SendGrid)'
            ],
            setup: [
                'Acesse "Configurações" no menu lateral (ícone de engrenagem)',
                'Na seção "Configurações Binance", cole sua API Key Spot',
                'Cole sua Secret Key Spot (ela só aparece uma vez na Binance - guarde com segurança!)',
                'Se tiver acesso a Futures, configure também as chaves Futures',
                'Na seção de notificações, informe seu email de recebimento',
                'Para Telegram, obtenha seu Chat ID e informe apenas o ID (não precisa do bot token)',
                'Clique em "Salvar" para confirmar todas as configurações',
                'Teste a conexão verificando se o Dashboard carrega seus saldos'
            ],
            tips: [
                'Nunca compartilhe suas chaves de API com ninguém',
                'Use apenas permissões necessárias (leitura e trading)',
                'Configure restrições de IP na Binance se possível',
                'Revise periodicamente suas chaves ativas na Binance'
            ]
        },
        {
            title: 'Símbolos e Mercados',
            subtitle: 'Escolha os pares de trading que deseja acompanhar',
            description: 'Os símbolos são os pares de criptomoedas que você deseja operar (ex: BTCUSDT, SOLUSDT). Ativar apenas os símbolos que você realmente usa reduz o ruído e facilita o monitoramento.',
            items: [
                'Símbolo: par de trading como BTCUSDT (Bitcoin em USDT) ou SOLBRL (Solana em Reais)',
                'Quote: moeda de referência (USDT, USDC, BUSD, BRL)',
                'Base: moeda que você está comprando/vendendo (BTC, SOL, ETH, etc.)',
                'Filtros: use os filtros por quote para encontrar rapidamente os pares desejados',
                'Ativação: apenas símbolos ativos aparecem nos monitores e estratégias',
                'Liquidez: evite pares com baixa liquidez para reduzir slippage'
            ],
            setup: [
                'Acesse "Símbolos" no menu lateral (dentro de Configurações)',
                'Use a barra de busca para encontrar o par desejado (ex: "BTC" ou "SOL")',
                'Filtre por quote usando o dropdown (USDT, USDC, BRL, etc.)',
                'Clique no botão de ativar/desativar ao lado de cada símbolo',
                'Símbolos ativos ficam destacados e aparecem em verde',
                'Salve suas preferências - elas serão usadas em Monitores e Estratégias'
            ],
            tips: [
                'Comece com poucos símbolos para não se perder',
                'Foque em pares com boa liquidez (volume alto)',
                'Use principalmente USDT como quote para maior compatibilidade',
                'Você pode ativar/desativar símbolos a qualquer momento'
            ]
        },
        {
            title: 'Monitores',
            subtitle: 'Sistema de observação que detecta sinais e eventos',
            description: 'Monitores são o "olho" do sistema. Eles observam continuamente os preços, volumes e indicadores técnicos dos símbolos que você configurou. Quando uma condição é atendida, o monitor dispara uma ação (alerta ou início de automação).',
            items: [
                'Tipo CANDLES: monitora velas (candles) e calcula indicadores técnicos em tempo real',
                'Intervalo: período de tempo das velas (1m, 5m, 15m, 1h, 4h, 1d)',
                'Indicadores: RSI, MACD, EMA, SMA, Bollinger Bands e muitos outros',
                'Símbolo: pode ser específico (BTCUSDT) ou genérico (* para todos os ativos)',
                'Ativo/Inativo: apenas monitores ativos estão observando o mercado',
                'Logs: habilite para ver detalhes de cada verificação do monitor',
                'Broadcast Label: identificador para diferenciar monitores similares'
            ],
            setup: [
                'Acesse "Monitores" no menu lateral',
                'Clique em "Novo Monitor" para criar um',
                'Selecione o tipo (geralmente CANDLES)',
                'Escolha o símbolo (ou * para todos)',
                'Defina o intervalo (ex: 5m para operações de curto prazo)',
                'Adicione indicadores separados por vírgula (ex: RSI_14,MACD_12_26_9,EMA_20)',
                'Marque "Ativo" se quiser que o monitor comece a funcionar imediatamente',
                'Salve o monitor - ele começará a observar o mercado automaticamente'
            ],
            tips: [
                'Use intervalos menores (1m, 5m) para operações rápidas e maiores (1h, 4h) para tendências',
                'Combine múltiplos indicadores para reduzir sinais falsos',
                'Teste monitores com logs ativados antes de criar automações',
                'Um monitor pode ser usado por várias estratégias diferentes'
            ]
        },
        {
            title: 'Indicadores Técnicos',
            subtitle: 'Ferramentas de análise técnica para tomar decisões',
            description: 'Indicadores técnicos são cálculos matemáticos baseados em preço e volume que ajudam a identificar tendências, momentum, sobrecompra/sobrevenda e outros padrões de mercado. Eles são usados dentro de Monitores e Estratégias.',
            items: [
                'RSI (Relative Strength Index): mede força relativa, valores acima de 70 indicam sobrecompra, abaixo de 30 sobrevenda',
                'MACD: identifica mudanças de momentum e cruzamentos de médias móveis',
                'EMA/SMA: médias móveis exponenciais e simples que suavizam o preço',
                'Bollinger Bands: indicam volatilidade e níveis de suporte/resistência',
                'Volume: quantidade negociada, útil para confirmar tendências',
                'Parâmetros: cada indicador tem parâmetros ajustáveis (ex: RSI_14 usa período de 14)',
                'Combinação: use múltiplos indicadores juntos para maior confiabilidade'
            ],
            setup: [
                'Os indicadores são configurados dentro dos Monitores',
                'Ao criar um Monitor, adicione os indicadores no campo "Índices"',
                'Formato: NOME_PARÂMETROS separados por vírgula (ex: RSI_14,MACD_12_26_9)',
                'Exemplos comuns: RSI_14, EMA_20, EMA_50, MACD_12_26_9, BB_20_2',
                'Salve o monitor e aguarde alguns minutos para os indicadores começarem a calcular',
                'Visualize os valores no Dashboard ou nos logs do monitor',
                'Use os valores dos indicadores nas condições das Automações'
            ],
            tips: [
                'RSI_14 é um dos mais populares para identificar reversões',
                'Combine EMA rápida (20) com EMA lenta (50) para identificar tendências',
                'MACD é excelente para detectar mudanças de momentum',
                'Ajuste os parâmetros conforme o ativo e o timeframe',
                'Teste diferentes combinações antes de usar em automações reais'
            ]
        },
        {
            title: 'Templates de Ordem',
            subtitle: 'Padronize suas ordens de compra e venda',
            description: 'Templates de Ordem são modelos pré-configurados que definem como você quer comprar ou vender. Eles agilizam a criação de ordens e garantem consistência nas operações. Use templates para evitar erros e padronizar seu método de trading.',
            items: [
                'Nome: identifique o template facilmente (ex: "Compra Rápida BTC", "Venda com Stop")',
                'Tipo: MARKET (execução imediata) ou LIMIT (preço específico)',
                'Lado: BUY (compra) ou SELL (venda)',
                'Quantidade: valor fixo (ex: 0.1), percentual do saldo (ex: 10%) ou "100%" para usar tudo',
                'Preço Limite: para ordens LIMIT, defina o preço máximo (compra) ou mínimo (venda)',
                'Stop Price: preço de stop-loss para limitar perdas',
                'Multiplicadores: ajuste valores dinamicamente nas automações',
                'Reutilização: um template pode ser usado por várias estratégias'
            ],
            setup: [
                'Acesse "Modelos de Ação" → "Ordem" no menu lateral',
                'Clique em "Novo Template de Ordem"',
                'Escolha o símbolo (ex: BTCUSDT)',
                'Dê um nome descritivo ao template',
                'Selecione o tipo (MARKET para execução rápida, LIMIT para preço específico)',
                'Escolha o lado (BUY para compra, SELL para venda)',
                'Defina a quantidade (ex: "10%" para usar 10% do saldo disponível)',
                'Para LIMIT, informe o preço limite desejado',
                'Opcionalmente, configure stop-loss',
                'Salve o template - ele estará disponível para uso em Estratégias e Automações'
            ],
            tips: [
                'Use MARKET para execução garantida e rápida',
                'Use LIMIT quando quiser comprar/vender em um preço específico',
                'Quantidade percentual (ex: 10%) é mais flexível que valor fixo',
                'Crie templates separados para compra e venda',
                'Teste templates com valores pequenos antes de usar em produção'
            ]
        },
        {
            title: 'Templates de Preço e Quantidade',
            subtitle: 'Regras avançadas para entrada e saída',
            description: 'Além dos Templates de Ordem básicos, existem Templates de Preço e Quantidade que permitem criar regras mais sofisticadas. Eles são usados principalmente em estratégias automatizadas para definir quando e quanto comprar/vender.',
            items: [
                'Template de Preço: define regras de entrada e saída baseadas em preço',
                'Template de Quantidade: define quanto comprar/vender de forma dinâmica',
                'Multiplicadores: ajuste valores em tempo real conforme condições do mercado',
                'Trailing Stop: stop-loss que acompanha o preço quando está em lucro',
                'Take Profit: preço alvo para realizar lucros automaticamente',
                'Percentuais: use % do saldo para adaptar-se a diferentes tamanhos de conta',
                'Integração: trabalham em conjunto com Templates de Ordem nas Estratégias'
            ],
            setup: [
                'Templates de Preço e Quantidade são configurados dentro das Estratégias',
                'Ao criar uma Estratégia, você pode definir regras de preço e quantidade',
                'Use valores percentuais para flexibilidade (ex: comprar 10% do saldo disponível)',
                'Configure take-profit e stop-loss para gerenciar risco',
                'Use trailing stop para proteger lucros em movimentos favoráveis',
                'Teste as regras em modo de simulação antes de ativar',
                'Ajuste os parâmetros conforme o comportamento do ativo'
            ],
            tips: [
                'Sempre defina stop-loss para limitar perdas potenciais',
                'Use take-profit para realizar lucros automaticamente',
                'Trailing stop é ideal para tendências fortes',
                'Percentuais são melhores que valores fixos para diferentes tamanhos de conta',
                'Revise e ajuste templates periodicamente conforme o mercado muda'
            ]
        },
        {
            title: 'Ordens e Operações',
            subtitle: 'Execute compras, vendas e swaps manualmente',
            description: 'Ordens são as operações de compra e venda executadas na Binance. Você pode criar ordens manualmente através das páginas Comprar/Vender, Swap ou EasyTrade. Todas as ordens são registradas e aparecem nos Relatórios para acompanhamento.',
            items: [
                'Comprar/Vender (Spot): página tradicional para ordens de mercado ou limite',
                'Swap: troca direta entre dois ativos (ex: SOL para USDT)',
                'EasyTrade: interface simplificada com wizard guiado para compra e venda',
                'Tipo MARKET: execução imediata ao preço de mercado atual',
                'Tipo LIMIT: execução apenas quando o preço atingir o valor especificado',
                'Confirmação: todas as ordens mostram estimativa antes de confirmar',
                'Histórico: todas as ordens ficam registradas em "Ordens" para consulta',
                'Status: acompanhe o status de cada ordem (NOVO, FILLED, CANCELED, etc.)'
            ],
            setup: [
                'Para compra/venda rápida: acesse "EasyTrade" e escolha a moeda',
                'Para swap: acesse "Swap" e selecione origem, destino e quantidade',
                'Para ordem avançada: acesse "Comprar/Vender" (Spot Execução em Tempo Real)',
                'Selecione o símbolo (ex: BTCUSDT)',
                'Escolha o tipo (MARKET para rápido, LIMIT para preço específico)',
                'Defina a quantidade ou valor em BRL que deseja usar',
                'Revise a estimativa de quantidade e valor total',
                'Confirme a ordem - ela será executada imediatamente na Binance',
                'Acompanhe o resultado em "Ordens" no menu lateral'
            ],
            tips: [
                'Use MARKET para garantir execução rápida',
                'Use LIMIT quando quiser um preço específico (pode não executar se o preço não atingir)',
                'EasyTrade é ideal para iniciantes - o wizard guia todo o processo',
                'Swap é útil para trocar entre moedas sem passar por USDT',
                'Sempre revise a estimativa antes de confirmar',
                'Monitore suas ordens para garantir que foram executadas corretamente'
            ]
        },
        {
            title: 'Estratégias',
            subtitle: 'Combine monitores, templates e regras de trading',
            description: 'Estratégias são o coração do sistema. Elas combinam um Monitor (que observa o mercado), Templates de Ordem (que definem como comprar/vender) e Automações (que executam as regras). Uma estratégia completa permite operar automaticamente baseado em suas regras personalizadas.',
            items: [
                'Monitor: observa o mercado e detecta quando condições são atendidas',
                'Automação de Compra: define quando e como comprar',
                'Automação de Venda: define quando e como vender',
                'Condições: regras baseadas em indicadores técnicos (ex: RSI < 30 para compra)',
                'Ações: o que fazer quando a condição é atendida (ex: executar template de compra)',
                'Ativação: estratégias podem ser ativadas/desativadas a qualquer momento',
                'Compartilhamento: você pode compartilhar estratégias com outros usuários',
                'Wizard: use o assistente para criar estratégias completas passo a passo'
            ],
            setup: [
                'Acesse "Estratégias" no menu lateral',
                'Clique em "Nova Estratégia" ou use o Wizard de Estratégia',
                'O Wizard guia você: primeiro cria o Monitor, depois os Templates, depois as Automações',
                'Defina o símbolo e intervalo de tempo',
                'Adicione indicadores técnicos ao monitor',
                'Crie templates de compra e venda',
                'Configure condições de compra (ex: RSI < 30 AND preço > EMA_20)',
                'Configure condições de venda (ex: RSI > 70 OR lucro > 2%)',
                'Associe as ações (executar templates) às condições',
                'Dê um nome à estratégia e salve',
                'Ative a estratégia quando estiver pronto para operar'
            ],
            tips: [
                'Comece com estratégias simples antes de criar regras complexas',
                'Teste estratégias com valores pequenos primeiro',
                'Use múltiplas condições (AND/OR) para reduzir sinais falsos',
                'Sempre defina stop-loss e take-profit nas automações',
                'Monitore estratégias ativas regularmente',
                'Use o Wizard se estiver começando - ele cria tudo automaticamente',
                'Revise estratégias compartilhadas da comunidade para aprender'
            ]
        },
        {
            title: 'Automações',
            subtitle: 'Bots que operam automaticamente por você',
            description: 'Automações são bots que executam suas estratégias de forma contínua, 24/7. Elas monitoram o mercado, verificam condições e executam ordens automaticamente quando suas regras são atendidas. Uma automação ativa trabalha sozinha, mas você deve monitorá-la regularmente.',
            items: [
                'Estratégia associada: cada automação usa uma estratégia específica',
                'Condições: regras que determinam quando executar ações (ex: RSI < 30)',
                'Ações: o que fazer quando condições são atendidas (ex: executar template de compra)',
                'Status: Ativa (operando) ou Inativa (pausada)',
                'Logs: registros detalhados de todas as verificações e execuções',
                'Limites: defina limites de risco (ex: máximo de ordens por dia)',
                'Monitoramento: acompanhe performance e ajuste conforme necessário',
                'Múltiplas automações: você pode ter várias automações rodando simultaneamente'
            ],
            setup: [
                'Primeiro, crie uma Estratégia completa (Monitor + Templates + Regras)',
                'Acesse "Automações" no menu lateral',
                'Clique em "Nova Automação"',
                'Selecione a estratégia que deseja automatizar',
                'Revise as condições e ações da automação',
                'Configure limites de risco (opcional)',
                'Ative os logs se quiser acompanhar detalhadamente',
                'Salve a automação',
                'Clique em "Iniciar" para começar a operar automaticamente',
                'Acompanhe o status e performance na lista de automações'
            ],
            tips: [
                'Sempre teste automações com valores pequenos primeiro',
                'Monitore automações ativas diariamente nas primeiras semanas',
                'Use logs para entender o comportamento da automação',
                'Defina limites claros de risco (ex: máximo 5% do saldo por operação)',
                'Pause automações em mercados muito voláteis ou incertos',
                'Ajuste condições e parâmetros conforme aprende com os resultados',
                'Use múltiplas automações para diferentes estratégias simultaneamente'
            ]
        },
        {
            title: 'Relatórios e Carteira',
            subtitle: 'Acompanhe resultados e gerencie seus ativos',
            description: 'Relatórios mostram o desempenho histórico de todas as suas operações, enquanto a Carteira exibe seus saldos atuais em tempo real. Use essas ferramentas para analisar performance, identificar oportunidades e gerenciar seu portfólio.',
            items: [
                'Relatórios: histórico completo de todas as ordens executadas',
                'Filtros: filtre por símbolo, tipo de ordem, data e moeda de referência (USDT, USDC, BRL)',
                'Métricas: lucro/perda, quantidade negociada, número de operações',
                'Gráficos: visualize performance ao longo do tempo',
                'Exportação: exporte dados para análise externa',
                'Carteira: saldos atuais de todas as moedas em tempo real',
                'Valor total: veja o valor total da carteira em BRL ou USDT',
                'Distribuição: visualize como seus ativos estão distribuídos',
                'Histórico de saldos: acompanhe evolução do patrimônio'
            ],
            setup: [
                'Acesse "Relatórios" no menu lateral para ver histórico de operações',
                'Use os filtros para encontrar operações específicas',
                'Selecione período, símbolo e tipo de ordem desejados',
                'Visualize gráficos de performance e estatísticas',
                'Acesse "Carteira" para ver saldos atuais',
                'A carteira mostra saldo disponível e bloqueado de cada moeda',
                'Valores são atualizados em tempo real conforme o mercado',
                'Use a carteira para planejar próximas operações',
                'Exporte relatórios quando necessário para análise detalhada'
            ],
            tips: [
                'Revise relatórios regularmente para identificar padrões',
                'Analise quais estratégias estão performando melhor',
                'Use filtros para focar em períodos ou símbolos específicos',
                'Compare performance entre diferentes estratégias',
                'Mantenha a carteira diversificada para reduzir risco',
                'Acompanhe a evolução do patrimônio ao longo do tempo',
                'Use os dados dos relatórios para ajustar suas estratégias'
            ]
        },
        {
            title: 'WebHooks e Integrações',
            subtitle: 'Conecte o EasyCripto com outros sistemas',
            description: 'WebHooks permitem que o EasyCripto se comunique com outros sistemas externos. Quando um evento acontece (ex: ordem executada, condição atendida), o sistema pode enviar uma notificação HTTP para uma URL configurada, permitindo integrações personalizadas.',
            items: [
                'WebHook: URL que recebe notificações quando eventos acontecem',
                'Eventos: ordem executada, automação iniciada, erro ocorrido, etc.',
                'Payload: dados enviados no formato JSON para sua URL',
                'Autenticação: use tokens ou assinaturas para garantir segurança',
                'Retry: sistema tenta reenviar se a URL não responder',
                'Logs: acompanhe todas as chamadas de webhook realizadas',
                'Uso comum: integrar com sistemas de alerta, dashboards externos ou bots personalizados'
            ],
            setup: [
                'Acesse "WebHooks" no menu lateral (dentro de Modelos de Ação)',
                'Clique em "Novo WebHook"',
                'Informe a URL que receberá as notificações',
                'Configure quais eventos devem disparar o webhook',
                'Adicione autenticação se necessário (headers customizados)',
                'Teste a URL antes de salvar',
                'Salve o webhook - ele começará a enviar notificações automaticamente',
                'Monitore os logs para verificar se as chamadas estão funcionando'
            ],
            tips: [
                'Use webhooks para criar alertas personalizados em outros sistemas',
                'Teste sempre a URL antes de ativar em produção',
                'Implemente tratamento de erros na sua URL receptora',
                'Use HTTPS para garantir segurança nas comunicações',
                'Monitore logs regularmente para detectar falhas',
                'Webhooks são úteis para integração com Telegram, Discord ou sistemas próprios'
            ]
        },
        {
            title: 'Agente IA e Funcionalidades Inteligentes',
            subtitle: 'Use inteligência artificial para otimizar seu trading',
            description: 'O EasyCripto possui um Agente IA integrado que pode sugerir estratégias, criar grids de trading e ajudar na tomada de decisões. Use essas funcionalidades para aprender, otimizar e automatizar ainda mais suas operações.',
            items: [
                'IA Sugerir Estratégia: o agente analisa o mercado e sugere estratégias personalizadas',
                'Estratégia Rápida: crie estratégias completas em poucos cliques com ajuda da IA',
                'IA Criar Grid: gera automaticamente grids de trading otimizados',
                'Agente IA: assistente conversacional que ajuda com dúvidas e configurações',
                'Análise de mercado: IA analisa condições atuais e sugere ações',
                'Otimização: use IA para encontrar melhores parâmetros de indicadores',
                'Aprendizado: o agente aprende com suas operações para melhorar sugestões'
            ],
            setup: [
                'Acesse "Inteligência" no menu lateral para ver opções de IA',
                'Use "IA Sugerir Estratégia" para receber recomendações personalizadas',
                'Informe seus objetivos (lucro alvo, período, risco)',
                'Revise a estratégia sugerida e ajuste se necessário',
                'Use "Estratégia Rápida" para criar estratégias completas rapidamente',
                'Acesse "IA Criar Grid" para gerar grids automatizados',
                'Use o "Agente IA" para tirar dúvidas e obter ajuda',
                'Monitore as estratégias criadas pela IA e ajuste conforme necessário'
            ],
            tips: [
                'Use IA como ponto de partida, mas sempre revise e ajuste estratégias',
                'Combine sugestões da IA com seu conhecimento de mercado',
                'Teste estratégias sugeridas pela IA com valores pequenos primeiro',
                'O agente melhora com o tempo conforme você usa o sistema',
                'Não dependa 100% da IA - use como ferramenta de apoio',
                'Revise periodicamente estratégias criadas pela IA e otimize'
            ]
        }
    ];

    const [stepIndex, setStepIndex] = useState(0);
    const step = steps[stepIndex];

    function goNext() {
        setStepIndex((current) => Math.min(current + 1, steps.length - 1));
    }

    function goPrev() {
        setStepIndex((current) => Math.max(current - 1, 0));
    }

    function goToStep(index) {
        setStepIndex(index);
    }

    return (
        <>
            <Menu />
            <main className="content">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                    <div className="d-block mb-4 mb-md-0">
                        <h1 className="h4">Treino Inicial</h1>
                        <p className="mb-0 text-gray">Guia completo e detalhado para dominar todas as funcionalidades do EasyCripto</p>
                    </div>
                </div>

                <div className="row mb-4">
                    <div className="col-12 col-lg-3 mb-4 mb-lg-0">
                        <div className="card border-0 shadow-sm h-100">
                            <div className="card-body p-3">
                                <h3 className="h6 mb-3">Índice do Treinamento</h3>
                                <div className="treino-index">
                                    {steps.map((s, index) => (
                                        <button
                                            key={`step-${index}`}
                                            className={`treino-index-item ${index === stepIndex ? 'active' : ''}`}
                                            onClick={() => goToStep(index)}
                                        >
                                            <span className="treino-index-number">{index + 1}</span>
                                            <span className="treino-index-title">{s.title}</span>
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-lg-9">
                        <div className="card border-0 shadow-sm">
                            <div className="card-body p-4">
                                <div className="treino-header mb-4">
                                    <div className="treino-step-indicator">
                                        <span className="treino-step-number">{stepIndex + 1}</span>
                                        <span className="treino-step-total">de {steps.length}</span>
                                    </div>
                                    <div className="flex-grow-1 ms-3">
                                        <h2 className="h4 mb-1">{step.title}</h2>
                                        <p className="text-muted mb-0">{step.subtitle}</p>
                                    </div>
                                </div>

                                <div className="progress mb-4 treino-progress">
                                    <div
                                        className="progress-bar bg-primary"
                                        role="progressbar"
                                        style={{ width: `${((stepIndex + 1) / steps.length) * 100}%` }}
                                        aria-valuenow={stepIndex + 1}
                                        aria-valuemin="0"
                                        aria-valuemax={steps.length}
                                    />
                                </div>

                                <div className="treino-description mb-4">
                                    <p className="lead">{step.description}</p>
                                </div>

                                <div className="row mb-4">
                                    <div className="col-12 col-lg-6 mb-3 mb-lg-0">
                                        <div className="treino-box">
                                            <h3 className="h6 mb-3 d-flex align-items-center">
                                                <svg className="icon icon-sm me-2 text-primary" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                                                </svg>
                                                O que é e para que serve
                                            </h3>
                                            <ul className="mb-0 ps-3">
                                                {step.items.map((item, idx) => (
                                                    <li key={`item-${idx}`} className="mb-2">{item}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-6 mb-3 mb-lg-0">
                                        <div className="treino-box">
                                            <h3 className="h6 mb-3 d-flex align-items-center">
                                                <svg className="icon icon-sm me-2 text-success" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                                </svg>
                                                Como configurar passo a passo
                                            </h3>
                                            <ol className="mb-0 ps-3">
                                                {step.setup.map((item, idx) => (
                                                    <li key={`setup-${idx}`} className="mb-2">{item}</li>
                                                ))}
                                            </ol>
                                        </div>
                                    </div>
                                </div>

                                {step.tips && step.tips.length > 0 && (
                                    <div className="treino-tips mb-4">
                                        <div className="alert alert-info mb-0">
                                            <h5 className="h6 mb-2 d-flex align-items-center">
                                                <svg className="icon icon-sm me-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                                                </svg>
                                                Dicas Importantes
                                            </h5>
                                            <ul className="mb-0 ps-3">
                                                {step.tips.map((tip, idx) => (
                                                    <li key={`tip-${idx}`} className="mb-1">{tip}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                )}

                                <div className="d-flex justify-content-between align-items-center mt-4 pt-4 border-top">
                                    <button
                                        className="btn btn-outline-secondary"
                                        onClick={goPrev}
                                        disabled={stepIndex === 0}
                                    >
                                        <svg className="icon icon-xs me-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
                                        </svg>
                                        Anterior
                                    </button>
                                    <div className="treino-dots">
                                        {steps.map((_, index) => (
                                            <button
                                                key={`dot-${index}`}
                                                className={`treino-dot ${index === stepIndex ? 'active' : ''}`}
                                                onClick={() => goToStep(index)}
                                                title={`Passo ${index + 1}: ${steps[index].title}`}
                                            >
                                                <span className="treino-dot-number">{index + 1}</span>
                                            </button>
                                        ))}
                                    </div>
                                    <button
                                        className="btn btn-primary"
                                        onClick={goNext}
                                        disabled={stepIndex === steps.length - 1}
                                    >
                                        Próximo
                                        <svg className="icon icon-xs ms-1" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Footer />
            </main>
        </>
    );
}

export default TreinoInicial;
